export default {
  getUserIdMiddlewareAuth(state) {
    return state.userIdMiddlewareAuth
  },
  getTokenMiddlewareAuth(state) {
    return state.tokenMiddlewareAuth
  },
  getEmailMiddlewareAuth(state){
    return state.emailMiddlewareAuth
  },
  isTrustPCMiddlewareAuth(state){
    return state.trustPCMiddlewareAuth
  },
  isAuthenticatedMiddlewareAuth(state) {
    return !!state.tokenMiddlewareAuth;
  },
  isAutoLogoutMiddlewareAuth(state) {
    return state.autologoutMiddlewareAuth;
  },
  getDisplayNameMiddlewareAuth(state) {
    return state.displayNameMiddlewareAuth;
  },
  getBasicUserDataMiddlewareAuth(state) {
    return state.basicUserDataMiddlewareAuth;
  },
	getUserNameMiddlewareAuth(state) {
		return state.userNameMiddlewareAuth;
	}
}
